export const CREATE_TAG_FAILURE = 'CREATE_TAG_FAILURE';

export const createTagFailure = (payload: Error) => ({
    type: CREATE_TAG_FAILURE,
    payload,
});
